
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import FeedbackList from "./components/FeedbackList"
import Header  from "./components/Header"
import FeedbackStats from "./components/FeedbackStats"
import FeedbackForm from "./components/FeedbackForm"
import AboutPage from "./pages/AboutPage"
import AboutIconLink from "./components/AboutIconLink"
import { FeedbackProvider } from "./context/FeedbackContext"



function App(){
    

    return (
        <FeedbackProvider>
            <Router>
                <Header />
                <div className="container">
                <Routes>
                    <Route path="/" element={
                        <>
                        <FeedbackForm />
                        <FeedbackStats />
                        <FeedbackList />
                        </>
                    }>
                    </Route>
                    <Route path='/about' element={<AboutPage />}/> 
                </Routes>
                </div>
                <AboutIconLink />
                
            </Router>
        </FeedbackProvider>   
    )
}

export default App